import { render, staticRenderFns } from "./Handicap.vue?vue&type=template&id=0b08f3d4&"
import script from "./Handicap.vue?vue&type=script&lang=js&"
export * from "./Handicap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports